import type { FrontendWidget } from '../types';
import { MagazineArticleContentComponent } from './MagazineArticleContentComponent';
import type {
  MagazineArticleContentConfig,
  MagazineArticleContentResolved,
} from './types';

/**
 * Inline, **context-backed** (30.03.05 § Classification): `resolveSync` and no
 * backend resolver — the block carries no fields and reads its entity from
 * `ctx.entities`.
 */
export const magazineArticleContentWidget: FrontendWidget<
  MagazineArticleContentConfig,
  MagazineArticleContentResolved
> = {
  componentType: 'magazine.article-content',
  // 70.14: adds no geometry of its own — it hands the article's blocks
  // straight to the renderer, which gives each one the page container.
  layout: 'self',
  displayName: 'Magazine Article Content',
  ComponentA: MagazineArticleContentComponent,
  resolveSync: () => ({}),
};
